import { OPPORTUNITY_CARD_TYPES } from '@components/OpportunityListing/utils/constants';
import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React from 'react';
import CornerElementSvg from './CornerElementSvg';

const OpportunityInfoStrip = ({
    isFestiveDeal,
    isAdminDeal,
    isClosed,
    interestPayoutFrequency,
    isUpcoming
}) => {
    if (isClosed || isUpcoming) return null;
    return (
        <div
            className={cn(
                'flex items-center bg-opp-info-strip rounded-bl-xl w-fit '
            )}
        >
            <div
                className={cn(
                    'relative w-fit py-1.5 px-3 pr-0 md:pl-4 border-primary-70 border-b-1 border-l border-r-0 rounded-bl-xl flex items-center gap-2 h-7',
                    {
                        'border-primary-500': isAdminDeal,
                        'border-[#D7BC5F] bg-basicWhite': isFestiveDeal,
                    }
                )}
            >
                {!isClosed && (
                    <>
                        <div className="flex items-center gap-1">
                            <Text
                                content={'Interest Payout'}
                                className="text-primary-500 p6-regular md:p5-regular"
                            />
                            <Text
                                content={interestPayoutFrequency}
                                className="text-primary-500 p6-semibold md:p5-semibold"
                            />
                        </div>
                    </>
                )}
            </div>
            <div className={cn('h-full place-content-center')}>
                <CornerElementSvg
                    isFestiveDeal={isFestiveDeal}
                    isAdminDeal={isAdminDeal}
                />
            </div>
        </div>
    );
};

export default OpportunityInfoStrip;
